module.exports = __webpack_public_path__ + "static/media/kamila.09fdd688.png";